module.exports = __webpack_public_path__ + "static/media/mymedic_qr_code.a48ff32c.svg";